import type { HeaderProps } from './types'

import { CourtesyNav } from './CourtesyNav'
import { HamburgerButton } from './HamburgerButton'
import { LogoLink } from './LogoLink'
import { MainNav } from './MainNav'
import type { getCourtesyNavItems } from './data'

type TopNavProps = {
  readonly toggleSideNav: (track?: boolean) => void
  readonly showSideNav: boolean
  readonly images: HeaderProps['images']
  readonly quoteWizard: HeaderProps['quoteWizard']
  readonly cartQuantity: number
  readonly courtesyNavItems: ReturnType<typeof getCourtesyNavItems>
}

export function TopNav({
  toggleSideNav,
  showSideNav,
  images,
  quoteWizard,
  cartQuantity,
  courtesyNavItems
}: TopNavProps) {
  return (
    <nav
      aria-label="top navigation"
      className="py-p-4 max-w-8xl mx-auto flex h-[50px] items-center gap-4 px-3 max-[1125px]:justify-between md:gap-8 md:px-8 md:py-0 min-[1126px]:h-[78px]"
    >
      <HamburgerButton onClick={toggleSideNav} open={showSideNav} />
      <LogoLink type="full" />
      <MainNav images={images} quoteWizard={quoteWizard} />
      <CourtesyNav
        cartQuantity={cartQuantity}
        images={images}
        items={courtesyNavItems}
        quoteWizard={quoteWizard}
      />
    </nav>
  )
}
